import React from 'react';
import PrivateRoute from '@shared/routing/PrivateRoute';
import SettingsPage from './user-management-page/SettingsPage';
import { Switch } from 'react-router';
import EditTeamPage from './EditTeamPage';
import CompanySettingsPage from './edit-company-page/CompanySettingsPage';
import EditUserPage from './EditUserPage';
import './user-management.scss';
import Layout from '@shared/ui/organisms/layout/Layout';
import OrphanedUsersPage from "./OrphanedUsers";
import PaymentsPage from "./payments-page/PaymentsPage";
import PersonalPreferencesPage from "./PersonalPreferencesPage";
import ManageTeamsAndUsersPage from "./user-management-page/ManageTeamsAndUsersPage";
import AdvanceHotDeskingPage from "./advance-hot-desking/AdvanceHotDeskingPage";
import ManageOfficesPage from "./advance-hot-desking/ManageOfficesPage";
import OfficeManagementPage from "./office-management-page/OfficeManagementPage";
import HolidaySettings from "./HolidaySettings";
import ManageAreasPage from "./advance-hot-desking/ManageAreasPage";
import ManageDesksPage from "./advance-hot-desking/ManageDesksPage";
import ReportingPageV2 from "./reporting-page/ReportingPageV2";
import { WhereaboutsReportingPage } from "@features/reporting/pages/WhereaboutsReportingPage";
import { MicrosoftActiveDirectorySync } from "./MicrosoftActiveDirectorySync";
import { HolidaysUsageReportingPage } from "@features/reporting/pages/HolidaysUsageReportingPage";
import { CompanyHolidaysPage } from "./company-holidays-page/CompanyHolidaysPage";
import { CrudCompanyHolidayPage } from "./company-holidays-page/CrudCompanyHolidayPage";
import { OfficeCheckInReportingPage } from "@features/reporting/pages/OfficeCheckInReportingPage";
import { UnknownWhereaboutsReportingPage } from "@features/reporting/pages/UnknownWhereaboutsReportingPage";
import { KeyResponsibilitiesPage } from "@features/reporting/pages/key-responsibilities-report/KeyResponsibilitiesPage";
import { AddMeetingRoomPage } from "./meeting-rooms/AddMeetingRoomPage";
import { EditMeetingRoomPage } from "./meeting-rooms/EditMeetingRoomPage";
import ManageDepartmentsPage from "./department-management-page/ManageTeamsAndUsersPage";
import EditDepartmentPage from "./department-management-page/EditDepartmentPage";
import { LineReportsReportingPage } from "@features/reporting/pages/LineReportsReportingPage";
import { CustomWhereaboutsPage } from "./custom-whereabouts/CustomWhereaboutsPage";
import { AuditLogsPage } from "./audit-logs/AuditLogsPage";
import { AddCustomWhereaboutsPage } from "./custom-whereabouts/AddCustomWhereaboutsPage";
import { HolidayAllowanceSettings } from "@features/holidays/pages/settings/HolidayAllowanceSettings";
import { UsersWhereaboutsReport } from "./user-whereabouts-report/UsersWhereaboutsReport";
import { OfficeUsageReportingPage } from "@features/reporting/pages/office-usage-report/OfficeUsageReportingPage";
import { OfficeManagementPageV2 } from "./office-management-page-v2/OfficeManagementPageV2";
import { OfficeListPageV2 } from "./office-management-page-v2/OfficeListPageV2";
import { CompanyManagementPageV2 } from "./company-management-page-v2/CompanyManagementPageV2";
import { HolidayCarryOverPreview } from "@features/holidays/pages/carry-over/HolidayCarryOverPreview";
import { HolidayCarryOverExpiryPreview } from "@features/holidays/pages/carry-over/HolidayCarryOverExpiryPreview";
import {
  DeskUtilizationReportingPage
} from "@features/reporting/pages/desk-utilization-report/DeskUtilizationReportingPage";
import {
  CarParkUtilizationReportingPage
} from "@features/reporting/pages/car-park-utilization-report/CarParkUtilizationReportingPage";
import {
  AutomaticOfficeCheckInReportingPage
} from "@features/reporting/pages/AutomaticOfficeCheckInReportingPage";
import {
  MeetingRoomUsageReportingPage
} from "@features/reporting/pages/meeting-room-usage-report/MeetingRoomUsageReportingPage";
import { VisitorReportingPage } from "@features/reporting/pages/visitor-report/VisitorReportingPage";
import { NoShowReportingPage } from "@features/reporting/pages/no-show-report/NoShowReportingPage";
import { OfficeHeatMapPage } from "@features/reporting/pages/office-heat-map/OfficeHeatMapPage";

export default function ManagementRouting() {
  return (
    <div className="managePage__container">
        <Switch>
          <PrivateRoute exact path="/manage/holidays/settings/allowance" component={HolidayAllowanceSettings} />
          <PrivateRoute exact path="/manage/holidays/settings/allowance-carry-over-preview" component={HolidayCarryOverPreview}/>
          <PrivateRoute exact path="/manage/holidays/settings/allowance-carry-over-expiry-days" component={HolidayCarryOverExpiryPreview}/>

          <PrivateRoute exact path="/manage/user/whereabouts-summary" component={UsersWhereaboutsReport} />
          <PrivateRoute exact path="/manage/user/:userId" component={EditUserPage} />
          <PrivateRoute exact path="/manage/preferences" component={PersonalPreferencesPage} />
          <PrivateRoute exact path="/manage/reporting/office" component={OfficeUsageReportingPage} />
          <PrivateRoute exact path="/manage/offices" component={OfficeListPageV2} />
          <PrivateRoute exact path="/manage/offices/add" component={OfficeManagementPageV2} />
          <PrivateRoute exact path="/manage/offices/:officeId" component={OfficeManagementPageV2} />
          <PrivateRoute exact path="/manage/company/:companyId" component={CompanyManagementPageV2} />
          <PrivateRoute exact path="/manage/teams-and-users" component={ManageTeamsAndUsersPage} />
          <PrivateRoute exact path="/manage/payments" component={PaymentsPage} />

          <Layout>
            <PrivateRoute exact path="/manage/reporting" component={ReportingPageV2} />
            <PrivateRoute exact path="/manage/reporting/whereabouts" component={WhereaboutsReportingPage} />
            <PrivateRoute exact path="/manage/reporting/holidays" component={HolidaysUsageReportingPage} />
            <PrivateRoute exact path="/manage/reporting/office-checkin" component={OfficeCheckInReportingPage} />
            <PrivateRoute exact path="/manage/reporting/unknown-whereabouts" component={UnknownWhereaboutsReportingPage} />
            <PrivateRoute exact path="/manage/reporting/key-responsibilities" component={KeyResponsibilitiesPage} />
            <PrivateRoute exact path="/manage/reporting/line-reports" component={LineReportsReportingPage} />
            <PrivateRoute exact path="/manage/reporting/desk-utilization" component={DeskUtilizationReportingPage} />
            <PrivateRoute exact path="/manage/reporting/car-parking-utilization" component={CarParkUtilizationReportingPage} />
            <PrivateRoute exact path="/manage/reporting/meeting-room-usage" component={MeetingRoomUsageReportingPage} />
            <PrivateRoute exact path="/manage/reporting/visitors" component={VisitorReportingPage} />
            <PrivateRoute exact path="/manage/reporting/automatic-checkin" component={AutomaticOfficeCheckInReportingPage} />
            <PrivateRoute exact path="/manage/reporting/no-shows" component={NoShowReportingPage} />
            <PrivateRoute exact path="/manage/reporting/office/heat-map" component={OfficeHeatMapPage} />
            <PrivateRoute exact path="/manage/user-sync" component={MicrosoftActiveDirectorySync} />
            <PrivateRoute exact path="/manage/audit-logs" component={AuditLogsPage} />
            <PrivateRoute exact path="/manage/company-holidays" component={CompanyHolidaysPage} />
            <PrivateRoute exact path="/manage/company-holidays/add" component={CrudCompanyHolidayPage} />
            <PrivateRoute exact path="/manage/company-holidays/view/:id" component={CrudCompanyHolidayPage} />
            <PrivateRoute exact path="/manage" component={SettingsPage} />
            <PrivateRoute exact path="/manage/meeting-rooms/add/:officeId" component={AddMeetingRoomPage} />
            <div className="managePage">
              <PrivateRoute exact path="/manage/departments" component={ManageDepartmentsPage} />
              <PrivateRoute exact path="/manage/departments/:departmentId" component={EditDepartmentPage} />
              <PrivateRoute exact path="/manage/whereabouts" component={CustomWhereaboutsPage} />
              <PrivateRoute exact path="/manage/custom-whereabouts" component={CustomWhereaboutsPage} />
              <PrivateRoute exact path="/manage/custom-whereabouts/add" component={AddCustomWhereaboutsPage} />
              <PrivateRoute exact path="/manage/custom-whereabouts/edit/:customWhereaboutsId" component={AddCustomWhereaboutsPage} />
              <PrivateRoute exact path="/manage/team/:teamId" component={EditTeamPage} />
              <PrivateRoute exact path="/manage/holidays" component={HolidaySettings} />
              <PrivateRoute exact path="/manage/global-settings/:companyId" component={CompanySettingsPage} />
              <PrivateRoute exact path="/manage/assign-users" component={OrphanedUsersPage} />
              <PrivateRoute exact path="/manage/advance-hot-desking-setup" component={AdvanceHotDeskingPage} />
              <PrivateRoute exact path="/manage/hot-desking" component={OfficeManagementPage} />
              <PrivateRoute exact path="/manage/hot-desking/add" component={ManageOfficesPage} />
              <PrivateRoute exact path="/manage/hot-desking/edit/:officeId" component={ManageOfficesPage} />
              <PrivateRoute exact path="/manage/hot-desking/edit/:officeId/areas" component={ManageAreasPage} />
              <PrivateRoute exact path="/manage/hot-desking/edit/:officeId/desks" component={ManageDesksPage} />
              <PrivateRoute exact path="/manage/meeting-rooms/edit/:meetingRoomId" component={EditMeetingRoomPage} />
            </div>
          </Layout>
        </Switch>
    </div>
  )
}
